import React, { useEffect, useState } from "react";
import CustomModal from "./Modal";
import { httpReauest } from "../../utils/httpRequest";
import { CDN_BASE_URL } from "../../config";
import copy from "clipboard-copy";

const UploadedModal = () => {
  const [show, setshow] = useState();
  const [data, setdata] = useState();

  useEffect(() => {
    getData();
  }, [show]);

  async function getData() {
    await httpReauest("GET", "/blog/uploaded", {}, {}).then((res) => {
      setdata(res.data.data);
    });
  }

  return (
    <>
      <div className="pt-2">
        <button
          type="button"
          className="btn-brand"
          onClick={() => setshow(true)}
        >
          آپلود های گذشته
        </button>
      </div>

      <CustomModal show={show} onHide={() => setshow(false)}>
        <div className="grid gap-5 lg:grid-cols-3">
          {data?.map((item) => {
            return (
              <span className="flex flex-col items-center">
                <img className="w-full" alt="" src={CDN_BASE_URL + item.path} />
                <p className="text-center mt-1">
                  {" "}
                  آدرس : {CDN_BASE_URL + item.path}
                </p>
                <button
                  onClick={() => copy(CDN_BASE_URL + item.path)}
                  type="button"
                  className="btn-brand mx-auto"
                >
                  کپی
                </button>
              </span>
            );
          })}
        </div>
      </CustomModal>
    </>
  );
};

export default UploadedModal;
